export enum DeliverableStrategies {
    EMAIL = 'EMAIL',
}
